




















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { PTOPolicy, PTOPolicyFilter } from "@/dto/payroll/policies/PTOPolicyDTO";
import Application from "@/state/Application";
import { processError } from "@/utils/ComponentUtils";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import PolicyService from "@/services/payroll/PolicyService";
import PTOPolicyCard from "@/components/payroll/policies/pto/PTOPolicyCard.vue";
import PTOCreationModal from "@/components/payroll/policies/pto/PTOCreationModal.vue";
import PTOAttachEmploymentsModal from "@/components/payroll/policies/pto/PTOAttachEmploymentsModal.vue";
import PolicySignatureOptions from "@/components/payroll/policies/PolicySignatureOptions.vue";
import PortalCollapse from "@/components/request/w9cr/PortalCollapse.vue";
import { prettyEnum } from "@/utils/StringUtils";

@Component({
	components: { PTOPolicyCard, PortalCollapse, PTOAttachEmploymentsModal }
})
export default class PTOAdminView extends Vue {
	private ptoList: PTOPolicy[] = [];
	private loading = true;

	private get companyId(): number | null {
		const id = this.$route.query.companyId;
		if (id == null || id === "") return null;
		const num = Number(id);
		return Number.isNaN(num) ? null : num;
	}

	private get currentYear(): number {
		return new Date().getFullYear();
	}

	private get policiesByYear(): Record<number, PTOPolicy[]> {
		const map: Record<number, PTOPolicy[]> = {};
		for (const p of this.ptoList) {
			const date = p.createDate instanceof Date ? p.createDate : new Date(p.createDate as unknown as string);
			const year = date.getFullYear();
			if (!map[year]) map[year] = [];
			map[year].push(p);
		}
		return map;
	}

	private get sortedYears(): number[] {
		const years = Object.keys(this.policiesByYear).map(Number);
		if (this.companyId != null && !years.includes(this.currentYear)) {
			years.push(this.currentYear);
		}
		return years.sort((a, b) => b - a);
	}

	private isEmptyYear(year: number): boolean {
		const list = this.policiesByYear[year];
		return !list || list.length === 0;
	}

	private activeForYear(year: number): PTOPolicy[] {
		return (this.policiesByYear[year] || []).filter(p => p.isActive && p.status !== 'DRAFT');
	}

	private inactiveForYear(year: number): PTOPolicy[] {
		return (this.policiesByYear[year] || []).filter(p => !p.isActive && p.status !== 'DRAFT');
	}

	private draftForYear(year: number): PTOPolicy[] {
		return (this.policiesByYear[year] || []).filter(p => p.status === 'DRAFT');
	}

	public created(): void {
		this.loadPolicies();
	}

	public beforeRouteUpdate(to: Route, from: Route, next: () => void): void {
		next();
		this.loadPolicies();
	}

	private loadPolicies(): void {
		if (this.companyId == null) {
			this.loading = false;
			return;
		}
		Application.startLoading();
		this.loading = true;
		const filter = new PTOPolicyFilter({
			companyId: this.companyId,
			isActive: null,
			pageSize: 100,
			pageNumber: 0
		});
		PolicyService.getPageOfPTOPolicies(filter).then(
			res => {
				this.ptoList = res.data.data || [];
				Application.stopLoading();
				this.loading = false;
			},
			err => {
				processError(err, this);
				this.loading = false;
				Application.stopLoading();
			}
		);
	}

	private confirmDisable(pto: PTOPolicy): void {
		this.$modal.show(DeleteConfirmation, {
			onDelete: () => this.disablePolicy(pto.id),
			targetName: pto.title,
			operationName: "disable"
		});
	}

	private disablePolicy(id: number): void {
		Application.startLoading();
		PolicyService.disablePTO(id).then(
			() => this.loadPolicies(),
			err => processError(err, this)
		);
	}

	private openCreateModal(): void {
		this.$modal.show(
			PTOCreationModal,
			{
				callback: () => this.loadPolicies(),
				companyId: this.companyId
			},
			{ height: "90%", width: "90%", scrollable: true }
		);
	}

	private openContinueDraftModal(pto: PTOPolicy): void {
		this.$modal.show(
			PTOCreationModal,
			{
				callback: () => this.loadPolicies(),
				companyId: this.companyId,
				draftPolicyId: pto.id
			},
			{ height: "90%", width: "90%", scrollable: true }
		);
	}

	private confirmDiscardDraft(pto: PTOPolicy): void {
		this.$modal.show(DeleteConfirmation, {
			onDelete: () => this.discardDraft(pto.id),
			targetName: pto.title,
			operationName: "discard"
		});
	}

	private discardDraft(policyId: number): void {
		Application.startLoading();
		PolicyService.deleteDraftPTO(policyId).then(
			() => this.loadPolicies(),
			err => processError(err, this)
		);
	}

	private showSignatureOptions(signature: import("@/dto/payroll/policies/PTOPolicyDTO").PolicySignature): void {
		this.$modal.show(PolicySignatureOptions, {
			signature,
			callback: () => this.loadPolicies(),
			mode: "PTO"
		});
	}

	private openAssignModal(pto: PTOPolicy): void {
		this.$modal.show(PTOAttachEmploymentsModal, {
			policyId: pto.id,
			companyId: pto.company.id,
			callback: () => this.loadPolicies(),
			assignedEmploymentIds: (pto.signatures || []).map(s => s.employment.id!).filter(Boolean)
		});
	}

	private prettyEnum = prettyEnum;
}
